// this file is generated by update_shopify_store_data.py at 2026-11-02 20:11:43.491966
var courses = [
    {
        "course_id": "F7295896-2627-EF11-998C-005056A7B953",
        "course_version": 3,
        "name": "Rapid Regs for Practitioners (California Employees Only)",
        "course_type": 32,
        "author_information": "",
        "description": "As an important component of a good healthcare compliance program, HealthStream\u2019s expert onboarding and annual training, ensures your physicians understand how to comply with federal laws and avoid activity that could lead to potential risk, liability, and administrative action. This curriculum is designed for practitioners in California who are NOT managers/supervisors.\r\n\r\nThese courses can be completed in one sitting if time permits or over the course of several learning sessions. Where available, the learner may achieve pre-assessment test-out.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1C55AE96-3224-EF11-9994-005056A716EA",
                "course_category_name": "HSTM - Rapid Regs for Practitioners - Curricula",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "1E05255A-B8D0-EE11-998B-005056A721AC",
                "course_version": 7,
                "name": "SQ Acute: Abuse and Neglect (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity helps learners recognize and understand the different types of abuse, the signs of abuse, and the reporting requirements of suspected or confirmed abuse. \r\n\r\nEsta actividad de aprendizaje ayuda a los participantes a reconocer y comprender los diferentes tipos de abuso, las se\u00f1ales de abuso y los requisitos de notificaci\u00f3n de abuso sospechado o confirmado.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Define abuse </li>\r\n    <li>Identify types of abuse and related signs and symptoms.\r\n    </li>\r\n    <li>    Describe actions to take to protect individuals from abuse. </li>\r\n    <li> Describe the reporting requirements for suspected or confirmed abuse.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Definir el abuso.</li>\r\n    <li>Identificar los tipos de abuso y los signos y s&iacute;ntomas relacionados.</li>\r\n    <li>Describir las acciones que se deben tomar para proteger a las personas del abuso.</li>\r\n    <li>Describir los requisitos de notificaci&oacute;n del abuso sospechado o confirmado.&nbsp;&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Intimate Partner Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0BB4475A-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Gerontology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                        "course_category_name": "Sexual Abuse & Assault",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3F4D9D32-F3FD-E611-BC44-005056B10E33",
                        "course_category_name": "Correctional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4A566AD5-0186-E811-A5DD-005056B150D3",
                        "course_category_name": "Pain",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "957F716A-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Infusion Therapy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A0CBF9A6-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Child Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B0FAB4D3-9106-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Abuse and Neglect",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DA6A4541-D28C-EB11-80DF-005056B134EC",
                        "course_category_name": "Mandatory Reporting",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Rehabilitation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E23CFC1B-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Dialysis",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E2202A8-0386-E811-ABAD-005056B17F80",
                        "course_category_name": "School",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FA20BE9F-C98C-EB11-80DF-005056B134EC",
                        "course_category_name": "Elder Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A15EF888-B9D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Adverse Drug Events (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity helps learners recognize adverse events, distinguish their severity, and identify populations at risk.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Define adverse drug events and list four types.</li>\r\n    <li>Distinguish the severity level of adverse drug reactions.</li>\r\n    <li>Recognize when to report drug reactions to the appropriate healthcare practitioner.</li>\r\n    <li>Recognize when to report drug reactions to MedWatch.</li>\r\n    <li>Identify populations at greatest risk of adverse drug events.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D8CF904-C697-EB11-80DE-005056B160AF",
                        "course_category_name": "Food & Drug Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2CB1C04-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Adverse Drug Events",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A4026D3B-BAD0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Antibiotic Resistance (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews what happens when antibiotics do not stop germs as they should, antibiotic use, and how to protect people from antibiotic resistance.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recall the definition of antibiotic resistance and how it impacts healthcare. </li>\r\n    <li>Recognize the infection prevention and control requirements and antibiotic stewardship related to the Conditions of Participation (CoPs). </li>\r\n    <li>Identify actions healthcare workers can take to protect individuals in their care and people in their community from antibiotic-resistant infections. </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E83D3B0C-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Centers for Medicare & Medicaid Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9996B0CC-BF26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Antibiotic Stewardship",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "0A6FF1B9-C4D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Infection, Transmission-Based Precautions (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity provides an overview of strategies and controls designed to prevent the healthcare-associated transmission of pathogens by the contact, droplet, and airborne routes.",
                "learning_objectives_html": "Upon completion of this learning activity, participant will be able to:\r\n<ul>\r\n    <li>Identify the three types of transmission-based precautions. </li>\r\n    <li>Identify the types of germs that require transmission-based precautions. </li>\r\n    <li>Recall how germs move from person to person. </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BD9F31D2-8506-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Transmission-Based Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A653B162-C5D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Medication Management, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews ordering, scheduling, and identifying medications. It will also identify best practices for preparing and administering medications along with the documentation requirements needed.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Recall the process for ordering, scheduling, and identifying medicines.</li>\r\n    <li>Identify best practices for preparing and administering medicines.</li>\r\n    <li>Indicate documentation requirements of medicine management.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5189FB23-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Medication Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "D0A935FB-C6D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Medications, Interactions (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity covers causes and types of common medication interactions. It emphasizes the important role of the pharmacist and describes actions to reduce the risk of an adverse medication event. Taking more than one medication increases the risk because medications can interact with each other and either increase or decrease the effects or cause side effects.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Identify types and causes of medication interactions.</li>\r\n    <li>Recognize the role of the pharmacist related to safe medication practices.</li>\r\n    <li>Recall best practices to prevent medication interactions.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5189FB23-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Medication Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "ED9F03BD-BBD0-EE11-998B-005056A721AC",
                "course_version": 5,
                "name": "SQ Acute: Anticoagulant Therapy and Risk Reduction (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity discusses types of anticoagulant therapy, common errors and risks, and preventive strategies to improve safety.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>List the types and common uses of anticoagulants.</li>\r\n    <li>Identify the risks, side effects, and common errors associated with anticoagulants.</li>\r\n    <li>Recognize best practices for giving anticoagulants and educating those who take them.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "441538F6-8606-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Anticoagulant Therapy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "8B02B9D7-C5D0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Medications, Hazardous (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity discusses the characteristics of hazardous medications. It will identify potential risks and best practices during preparation, administration, care, and disposal. This will also review the importance of medical surveillance.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li> Identify characteristics of hazardous medications, mechanisms of harm, and potential exposure risks during each step of medication handling and use. </li>\r\n    <li>Recognize credible resources for hazardous medication handling and best practices to prevent exposure during preparation, administration, care, and disposal. </li>\r\n    <li>Recall the requirements for medical surveillance when hazardous medications are handled routinely.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC261434-EBF9-E611-AF66-005056B104B1",
                        "course_category_name": "Oncologic Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "830AFE10-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: High Risk Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "6ABA8BBA-CDD0-EE11-998B-005056A721AC",
                "course_version": 2,
                "name": "SQ Acute: Patient Rights, Advance Directives (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module describes advance directives and provides an overview of different types and how the directives differ from advance orders. The module also discusses legal requirements and healthcare provider roles.",
                "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Define and describe types of advance directives.\r\n    </li>\r\n    <li>    Distinguish advance directives from advance orders.\r\n    </li>\r\n    <li>    Describe a healthcare professional&rsquo;s role related to advance directives.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F7C5BD13-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Advance Directives",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D62C2A1-136D-E911-9E21-005056B13721",
                        "course_category_name": "Conditions of Participation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "B95F92F6-C3D0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Infection, Healthcare-Associated, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity covers infection control and antimicrobial stewardship in healthcare, and reviews reportable infections and how to protect individuals from them. It will also discuss healthcare-associated infections that are of urgent concern. This content is designed for clinical personnel.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the characteristics of effective infection control and antimicrobial stewardship programs.\r\n    </li>\r\n    <li>    List resistant germs seen in healthcare.\r\n    </li>\r\n    <li>    Recognize ways to protect individuals and stop outbreaks from resistant germs.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9FEBCF0-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Personal Protective Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "085322BE-8506-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Healthcare-Associated Infections",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "80A91C76-CED0-EE11-998B-005056A721AC",
                "course_version": 5,
                "name": "SQ Acute: Patient Rights, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This module emphasizes the importance of understanding and respecting patient rights. It includes the list of patient rights from the Conditions of Participation (CoP) for hospitals. This content is intended for clinical personnel.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the patient's rights under the conditions of participation for hospitals.</li>\r\n    <li>\r\n    Recognize a healthcare professional's responsibilities regarding patient rights.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2115A6DC-9106-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Patient Rights",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Medical Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                        "course_category_name": "zRemoved-Cardiovascular Perfusionist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "98A79B9E-B6D0-EE11-998B-005056A721AC",
                "course_version": 5,
                "name": "SQ Acute: Abduction, Infant and Child (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews the root causes of infant and child abductions, a healthcare worker's role in preventing them, and the best practices for keeping infants and children safe in a facility.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe the characteristics of an abductor.</li>\r\n    <li>Identify best practices for preventing abduction.\r\n    </li>\r\n    <li>    State\u202ffamily and staff education that will help prevent abduction.\r\n    </li>\r\n    <li>    Specify\u202fthe appropriate staff response to an attempted or actual abduction.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "122F6D1F-C126-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Patient or Resident Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9E2202A8-0386-E811-ABAD-005056B17F80",
                        "course_category_name": "School",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Patient Advocacy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "14BB9F58-BDD0-EE11-998B-005056A721AC",
                "course_version": 7,
                "name": "SQ Acute: Care Delivery, Culturally Competent (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity describes what culture means and how to provide equal and fair treatment to everyone. It describes how culturally sensitive care provides the best medical outcomes. The participant will learn about the outcomes of being sensitive and not being sensitive to an individual's culture.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define the meaning of culture.\r\n    </li>\r\n    <li>    Indicate how to provide equal and fair treatment to everyone.\r\n    </li>\r\n    <li>    Identify outcomes of being sensitive and not being sensitive to an individual's culture.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ADFB6B18-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Cultural Awareness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C4C69461-2D0C-EC11-80E5-005056B16B79",
                        "course_category_name": "Competency: Cultural Competency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "1A738077-BED0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: COVID-19 Emergency Temporary Standard (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Kathleen Greene-Batt",
                "description": "This learning activity reviews the OSHA Emergency Temporary Standard. It has been updated to include information based on changes made since the end of the federal Public Health Emergency was declared.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>List three ways that COVID-19 is transmitted.</li>\r\n    <li>Identify signs and symptoms of COVID-19.</li>\r\n    <li>Identify required protective measures to take when working with suspected or confirmed cases of COVID-19.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E4265595-BE26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: COVID-Related",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C74C5EEC-1C42-11DD-8EF5-001517135513",
                        "course_category_name": "Disaster Planning",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "4F988808-C2D0-EE11-998B-005056A721AC",
                "course_version": 6,
                "name": "SQ Acute: Ergonomics and Safe Lifting, Clinical (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity defines ergonomics and gives examples of where and how ergonomics can be applied in the workplace. Musculoskeletal disorders (MSDs) are explained, and suggestions are made about how to prevent back pain and injury using ergonomic tools and equipment. The learning activity also reviews three primary risk factors for injury during physical tasks, proper body mechanics for manual lifting, when to use mechanical equipment or assistive devices, and gives examples of lifting equipment and assistive devices. This learning activity content is designed for clinical personnel.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe the risks of manually handling individuals and how to reduce risks.\r\n    </li>\r\n    <li>    Specify the importance of an assessment before a lift or transfer.\r\n    </li>\r\n    <li>    Identify specific ways to lift or transfer people and objects.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D04DB9A7-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Workflow Efficiency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6D11B708-6F06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Ergonomics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Workforce Culture",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "09A3C12D-D505-EC11-80E5-005056B107A8",
                        "course_category_name": "Risk Area: Employee Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "2BD8F2C8-C2D0-EE11-998B-005056A721AC",
                "course_version": 5,
                "name": "SQ Acute: Fire Safety (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews the basics of fire safety, how to respond to a fire in a facility, and how to prevent fires from happening.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize how fires can start.\r\n    </li>\r\n    <li>    Specify how to respond to and evacuate from a fire.\r\n    </li>\r\n    <li>    Identify what to do to lower the risk of fires.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "98B27526-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Electrical Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C4246662-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "64D94663-C3D0-EE11-998B-005056A721AC",
                "course_version": 6,
                "name": "SQ Acute: Hazard Communication (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity explains how OSHA's Hazard Communication Standard (HCS) classifies a chemical as a physical hazard or a health hazard and reviews specific PPE that should be used when working near or with hazardous chemicals. The learning activity also explains in detail what must be on a label, including explanations of the nine pictograms, as well as the sixteen components of a safety data sheet (SDS).\r\n\r\nEste m\u00f3dulo explica c\u00f3mo la Norma de Comunicaci\u00f3n de Peligros (HCS) de la OSHA clasifica una sustancia qu\u00edmica como peligro f\u00edsico o peligro para la salud y revisa los EPP espec\u00edficos que deben utilizarse cuando se trabaja cerca o con sustancias qu\u00edmicas peligrosas. El m\u00f3dulo tambi\u00e9n explica en detalle lo que debe figurar en una etiqueta, incluidas las explicaciones de los nueve pictogramas, as\u00ed como los diecis\u00e9is componentes de una ficha de datos de seguridad (SDS).",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify types of chemical hazards in the healthcare setting.\r\n    </li>\r\n    <li>    Discuss protective measures used when working with hazardous chemicals.\r\n    </li>\r\n    <li>    Recognize three common chemical hazards in hospitals: Formaldehyde , Glutaraldehyde, and Ethylene Oxide.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Identificar los tipos de riesgos qu&iacute;micos en el entorno de atenci&oacute;n m&eacute;dica.</li>\r\n    <li>Analizar las medidas de protecci&oacute;n utilizadas al trabajar con sustancias qu&iacute;micas peligrosas.</li>\r\n    <li>Reconocer tres riesgos qu&iacute;micos comunes en los hospitales: formaldeh&iacute;do, glutaraldeh&iacute;do y &oacute;xido de etileno.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EF2C23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Effective Communication",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5559DC85-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Hazard Communication",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "10E18C74-C6D0-EE11-998B-005056A721AC",
                "course_version": 3,
                "name": "SQ Acute: Medications, High-Alert (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "According to the Institute for Safe Medication Practices (ISMP), high-alert medications are those that have an increased risk of causing significant patient harm when used in error.\u00a0This learning activity will review some important information on the ISMP list and best practices when giving people high-alert medications.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>List the most common high-alert medication classes.</li>\r\n    <li>Identify recommended strategies for protecting individuals from adverse drug events.</li>\r\n    <li>Recognize the appropriate response to a medication error.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Medication Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Medication Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "830AFE10-8706-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: High Risk Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C2068A6B-F3FD-E611-BC44-005056B10E33",
                        "course_category_name": "Diabetic Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "37655999-C7D0-EE11-998B-005056A721AC",
                "course_version": 5,
                "name": "SQ Acute: Medications, Preventing Rehospitalization (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity will identify medication groups that may increase risk of rehospitalizations and emergency department visits from adverse drug events (ADE). It will also discuss best practices to help decrease or prevent hospital visits due to ADEs.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Identify medicines known to increase risk for emergency department visits and hospitalizations.</li>\r\n    <li>Indicate clinical considerations and best practices when individuals require specific medicines.</li>\r\n    <li>Recognize the role of professional responsibility in decreasing emergency department visits and hospitalizations in relation to adverse drug events.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "01265A0C-C126-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Discharge Planning",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3827D9B3-CBD0-EE11-998B-005056A721AC",
                "course_version": 5,
                "name": "SQ Acute: National Performance Goals (NPGs), Basics (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Carleigh Davis",
                "description": "This learning activity reviews the Joint Commission's National Performance Goals (NPGs). It will review important details of each of the 14 NPGs goals.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Identify the national performance goals (NPGs).</li>\r\n    <li>Indicate the importance, purpose, and significance of each NPG.</li>\r\n    <li>Recognize how healthcare professionals can support each goal.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Rehabilitation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C5D2C33F-369B-EC11-80ED-005056B1202E",
                        "course_category_name": "Competency: Performance Improvement",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "05DBEBFD-CED0-EE11-998B-005056A721AC",
                "course_version": 4,
                "name": "SQ Acute: Restraint and Seclusion (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews the basics of restraints and the risks associated with restraints and seclusion. The Centers for Medicare and Medicaid Services Conditions of Participation guidelines for the use of restraints and seclusion are discussed.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe elements of the restraint and seclusion Conditions of Participation.\r\n    </li>\r\n    <li>    Identify risks when using physical and chemical restraints.\r\n    </li>\r\n    <li>    Specify regulations that guide the safe use of restraints and seclusion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DF0AFF1A-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Restraints and Seclusion",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "D51BBF38-16D0-EE11-9987-005056A7DAD4",
                "course_version": 7,
                "name": "CQ State: Preventing Sexual Harassment for Employees, California (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Barbara Boyne, MBA, BSN, RN",
                "description": "This learning activity is about the federal and California State laws that protect against sexual harassment. This learning activity will review types of sexual harassment, strategies to prevent sexual harassment, and employer responsibilities under California law. It also explains the rights of people affected by sexual harassment and how to report sexual harassment.\r\n\r\nThis learning activity is intended to assist Customers and Users with understanding and addressing minimum training requirements for all care settings in California for this topic. The content provided does not constitute legal or clinical advice and does not guarantee compliance with all applicable federal and state laws and regulations. This learning activity may also satisfy training requirements for other settings in various states; however, no representation or warranty is made as to its applicability. Customers remain solely responsible for ensuring that their training programs comply with all requirements established by their relevant governing entities and that individual care is customized by and aligned with provider orders and facility policies and procedures.",
                "learning_objectives_html": "After completing this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Define sexual harassment and the different types of harassment.</li>\r\n    <li>Recognize ways to prevent sexual harassment in the workplace.</li>\r\n    <li>Identify actions to take for a person affected by sexual harassment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "47413AC4-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Competency: Sexual Harassment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB3723AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Sexual Harassment Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B1A43098-5130-EC11-80E8-005056B16B79",
                        "course_category_name": "Risk Area: Harassment Laws",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EC0FB4EC-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "State Sexual Harassment Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9CBA98F-C688-F011-999D-005056A7F5E9",
                        "course_category_name": "_ComplyQ: State",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "BF324D06-1AD0-EE11-9987-005056A7DAD4",
                "course_version": 6,
                "name": "SQ Acute: Suicide Risks and Prevention (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews the risk factors and warning signs of a person at risk of suicide. It explains what healthcare workers can do to help prevent suicide and provides information about resources available to the individual, family members, and healthcare workers.\r\n\r\nEsta actividad de aprendizaje revisa los factores de riesgo y las se\u00f1ales de advertencia de una persona en riesgo de suicidio. Explica qu\u00e9 pueden hacer los trabajadores de la salud para ayudar a prevenir el suicidio y proporciona informaci\u00f3n sobre los recursos disponibles para la persona, los familiares y los trabajadores de la salud.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify individuals who are at risk for self-harm.\r\n    </li>\r\n    <li>    Recognize environmental safety risks for those at risk for self-harm.\r\n    </li>\r\n    <li>    Describe safety interventions for those at risk for self-harm for individuals on non-psychiatric units.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Identificar a las personas que est&aacute;n en riesgo de autolesi&oacute;n.</li>\r\n    <li>Reconocer los riesgos de seguridad en el entorno para las personas en riesgo de autolesi&oacute;n.</li>\r\n    <li>Describir intervenciones de seguridad para personas en riesgo de autolesi&oacute;n que se encuentran en unidades no psiqui&aacute;tricas.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A9A5001-8806-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Suicide Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Patient or Resident Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Professional Development",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "52BA5D27-1BD0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "SQ Acute: Infection, Emerging (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity provides an overview of emerging infections. It includes a review of factors that influence the emergence of new pathogens and examples of recent emergent infections. This learning activity also reviews how staff can prepare and learn about new emerging infections.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Define emerging infectious diseases and factors that affect the development of a new illness.</li>\r\n    <li>Recognize examples of recent emerging diseases.</li>\r\n    <li>Identify emergency preparedness and how to stay informed about new infectious diseases.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9FEBCF0-CC8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Personal Protective Equipment",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC8209E9-BE26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "B6E27C67-1CD0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "SQ Acute: Emergency Preparedness (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity provides an overview of an emergency preparedness program, including the structure of a program and why emerging infectious diseases should be considered. The learning activity will also discuss staff roles and training in response to an emergency.\u00a0\r\n\r\nEsta actividad de aprendizaje ofrece una visi\u00f3n general de un programa de preparaci\u00f3n para emergencias, incluida la estructura del programa y la raz\u00f3n por la cual deben considerarse las enfermedades infecciosas emergentes. La actividad de aprendizaje tambi\u00e9n abordar\u00e1 las funciones del personal y la capacitaci\u00f3n en respuesta a una emergencia.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe an emergency preparedness program.\r\n    </li>\r\n    <li>    Explain the importance of including emerging infectious diseases in the hazard assessment and planning for these situations.\r\n    </li>\r\n    <li>    Describe staff responsibilities during an emergency.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante ser&aacute; capaz de:\r\n<ul>\r\n    <li>\r\n    Describir un programa de preparaci&oacute;n para emergencias.</li>\r\n    <li>Explicar la importancia de incluir las enfermedades infecciosas emergentes en la evaluaci&oacute;n de riesgos y en la planificaci&oacute;n para estas situaciones.</li>\r\n    <li>Describir las responsabilidades del personal durante una emergencia.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C74C5EEC-1C42-11DD-8EF5-001517135513",
                        "course_category_name": "Disaster Planning",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "068B2671-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Emergency Preparedness",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3275577D-25D0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "CQ Acute: Anti-Kickback Statute (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Barbara Boyne, MBA, BSN, RN",
                "description": "This learning activity is about the Anti-Kickback Statute and the impact of kickbacks on healthcare. It will cover the reporting process and penalties for violations.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Identify key parts of the Anti-Kickback Statute.</li>\r\n    <li>Recognize how to report violations.</li>\r\n    <li>Specify penalties for violations.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CD580EB3-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Anti-Kickback Statute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3592490B-28D0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "CQ Acute: False Claims Act (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Jackie Luchsinger, PhD, MBA, MS, RN, PMP",
                "description": "This learning activity reviews the prohibitions of the False Claims Act (FCA) and provides examples of false claims for the learner to consider. A review of reporting processes includes the qui tam provision. The module concludes with a description of potential penalties for FCA violations.\r\n\r\nEsta actividad de aprendizaje repasa las prohibiciones de la Ley de Reclamaciones Falsas (FCA, por sus siglas en ingl\u00e9s) y proporciona ejemplos de reclamaciones falsas para que el participante las analice. La revisi\u00f3n de los procesos de reporte incluye la disposici\u00f3n qui tam. El m\u00f3dulo concluye con una descripci\u00f3n de las posibles sanciones por violaciones de la FCA.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Discuss the purpose and benefit of the False Claims Act (FCA).\r\n    </li>\r\n    <li>\r\n    Recognize the basic prohibition of the FCA.\r\n    </li>\r\n    <li>\r\n    Give examples of false claim types.\r\n    </li>\r\n    <li>\r\n    Identify the proper reporting process related to identification of potentially false claims including the qui tam provision.\r\n    </li>\r\n    <li>\r\n    Describe the potential penalties for submission of false claims.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Analizar el prop&oacute;sito y los beneficios de la Ley de Reclamaciones Falsas (FCA, por sus siglas en ingl&eacute;s).</li>\r\n    <li>Reconocer la prohibici&oacute;n b&aacute;sica establecida por la FCA.</li>\r\n    <li>Proporcionar ejemplos de tipos de reclamaciones falsas.</li>\r\n    <li>Identificar el proceso adecuado de reporte relacionado con la identificaci&oacute;n de posibles reclamaciones falsas, incluida la disposici&oacute;n qui tam.</li>\r\n    <li>Describir las posibles sanciones por la presentaci&oacute;n de reclamaciones falsas.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E3F830C8-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: False Claims Act",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "CD6565DC-28D0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "CQ Acute: Fraud, Waste, and Abuse (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Jen Bailey McKinney, MBA",
                "description": "This learning activity is about laws and regulations related to\u00a0fraud, waste, and abuse.\u00a0Compliance programs, penalties, and reporting are also covered.\r\n\r\nEsta actividad de aprendizaje trata sobre las leyes y regulaciones relacionadas con el fraude, el desperdicio y el abuso. Tambi\u00e9n aborda los programas de cumplimiento, las sanciones y los procesos de notificaci\u00f3n.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define fraud, waste, and abuse. </li>\r\n    <li>\r\n    Identify laws that help prevent fraud, waste, and abuse. </li>\r\n    <li>\r\n    Recognize types of penalties for violation of fraud, waste, and abuse laws. </li>\r\n    <li>\r\n    Describe how to report suspected violation of fraud, waste, and abuse laws.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Definir el fraude, el desperdicio y el abuso.</li>\r\n    <li>Identificar las leyes que ayudan a prevenir el fraude, el desperdicio y el abuso.</li>\r\n    <li>Reconocer los tipos de sanciones por violaciones a las leyes sobre fraude, desperdicio y abuso.</li>\r\n    <li>Describir c&oacute;mo reportar una presunta violaci&oacute;n de las leyes sobre fraude, desperdicio y abuso.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9F4A29D6-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fraud, Waste & Abuse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3AFAD70D-1DD0-EE11-9987-005056A7DAD4",
                "course_version": 10,
                "name": "SQ Acute: Bloodborne Pathogens and Standard Precautions, Clinical (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews how to protect self, coworkers, people receiving care, and others from bloodborne pathogens. Discussion is included on bloodborne pathogens found in the blood and body fluids and how they spread, as well as standard precautions to prevent the spread of these pathogens. The content in this learning activity is designed for clinical personnel. \r\n\r\nEsta actividad de aprendizaje revisa c\u00f3mo protegerse a uno mismo, a los compa\u00f1eros de trabajo, a las personas que reciben atenci\u00f3n y a otras personas contra los pat\u00f3genos transmitidos por la sangre. Incluye una discusi\u00f3n sobre los pat\u00f3genos transmitidos por la sangre que se encuentran en la sangre y los fluidos corporales, c\u00f3mo se propagan, as\u00ed como las precauciones est\u00e1ndar para prevenir la propagaci\u00f3n de estos pat\u00f3genos. El contenido de esta actividad de aprendizaje est\u00e1 dise\u00f1ado para el personal cl\u00ednico.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Identify bloodborne pathogens risks to healthcare workers, people receiving care, and others.\r\n    </li>\r\n    <li>    Describe protective measures to minimize exposure risk.</li>\r\n    <li>    Discuss the appropriate actions to take in the event of exposure to a BBP.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>\r\n    Identificar los riesgos de los pat&oacute;genos transmitidos por la sangre para los trabajadores de la salud, las personas que reciben atenci&oacute;n y otras personas.</li>\r\n    <li>Describir las medidas de protecci&oacute;n para minimizar el riesgo de exposici&oacute;n.</li>\r\n    <li>Analizar las acciones apropiadas que se deben tomar en caso de exposici&oacute;n a un pat&oacute;geno transmitido por la sangre (BBP).</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B0B50CB8-8506-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Bloodborne Pathogens",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CED83BE-FF85-E811-AD45-005056B16A47",
                        "course_category_name": "Occupational Safety & Health Administration",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                        "course_category_name": "Bloodborne Pathogens",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "5257BDEB-2AD0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "CQ Acute: HIPAA, Security Rule (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Jen Bailey McKinney, MBA",
                "description": "This learning activity provides an overview of the HIPAA Security Rule. It includes a review of how to protect electronic protected health information (ePHI), behaviors and situations that put ePHI at risk, the safeguards and requirements of the Security Rule, and reporting possible violations.\r\n\r\nEsta actividad de aprendizaje proporciona una visi\u00f3n general de la Regla de Seguridad de HIPAA. Incluye una revisi\u00f3n de c\u00f3mo proteger la informaci\u00f3n de salud protegida electr\u00f3nica (ePHI, por sus siglas en ingl\u00e9s), los comportamientos y situaciones que ponen en riesgo la ePHI, las salvaguardas y los requisitos de la Regla de Seguridad, as\u00ed como el reporte de posibles violaciones.",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Distinguish the HIPAA Privacy Rule from the HIPAA Security Rule.</li>\r\n    <li>\r\n    Identify common behaviors and situations that put PHI at risk for unintended disclosure.</li>\r\n    <li>\r\n    Identify external risks to PHI.</li>\r\n    <li>\r\n    Identify best practices and required safeguards organizations must take to ensure appropriate protection of electronic protected health information.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Diferenciar la Regla de Privacidad de HIPAA de la Regla de Seguridad de HIPAA.</li>\r\n    <li>Identificar comportamientos y situaciones comunes que ponen en riesgo la informaci&oacute;n de salud protegida (PHI) ante una divulgaci&oacute;n no intencionada.</li>\r\n    <li>Identificar riesgos externos para la PHI.</li>\r\n    <li>Identificar las mejores pr&aacute;cticas y las salvaguardas requeridas que las organizaciones deben implementar para garantizar la protecci&oacute;n adecuada de la informaci&oacute;n de salud protegida electr&oacute;nica (ePHI).</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "622D5A09-2CD0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "CQ Acute: HIPAA, Violations and Penalties (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Tasha Deitschman, MSN, RN, CPPS",
                "description": "This learning activity will provide an overview of the HIPAA Privacy Rule\u2019s disclosure violations as well as the associated penalties. It will define and discuss examples of breaches of protected health information (PHI) as well as review commonly occurring HIPAA compliance issues.\r\n\r\nEsta actividad de aprendizaje proporcionar\u00e1 una visi\u00f3n general de las violaciones relacionadas con la divulgaci\u00f3n de informaci\u00f3n seg\u00fan la Regla de Privacidad de HIPAA, as\u00ed como de las sanciones asociadas. Definir\u00e1 y analizar\u00e1 ejemplos de violaciones de la informaci\u00f3n de salud protegida (PHI, por sus siglas en ingl\u00e9s) y tambi\u00e9n revisar\u00e1 problemas comunes de cumplimiento de HIPAA que ocurren con frecuencia.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Define a breach of protected health information (PHI).</li>\r\n    <li>Describe the types of exceptions to a breach of PHI.</li>\r\n    <li>Describe the types of Privacy disclosure violations.</li>\r\n    <li>Recognize commonly occurring HIPAA compliance issues.</li>\r\n    <li>Describe the civil and criminal penalties associated with HIPAA violations. </li>\r\n</ul>\r\nAl completar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Definir una violaci&oacute;n de la informaci&oacute;n de salud protegida (PHI).</li>\r\n    <li>Describir los tipos de excepciones a una violaci&oacute;n de la PHI.</li>\r\n    <li>Describir los tipos de infracciones relacionadas con la divulgaci&oacute;n de informaci&oacute;n protegida por la Regla de Privacidad.</li>\r\n    <li>Reconocer los problemas de cumplimiento de la HIPAA que ocurren con mayor frecuencia.</li>\r\n    <li>Describir las sanciones civiles y penales asociadas con las violaciones de la HIPAA.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "51E3B198-1AD0-EE11-9987-005056A7DAD4",
                "course_version": 8,
                "name": "SQ Acute: Infection, Tuberculosis (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity reviews the causes of tuberculosis (TB), risk factors, symptoms, transmission, and prevention of tuberculosis.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Indicate how tuberculosis (TB) is transmitted.\r\n    </li>\r\n    <li>    Identify risk factors for TB infection.\r\n    </li>\r\n    <li>    Recall measures to prevent TB.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BC8209E9-BE26-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                        "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Infection Control and Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "57ADBACD-1BD0-EE11-9987-005056A7DAD4",
                "course_version": 6,
                "name": "SQ Acute: Fire Safety, Fire Extinguisher Use (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity provides an overview of the different types of fire extinguishers and how to use them properly. It also reviews when someone can safely stay to fight a fire and when they should flee.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the different types of fire extinguishers.\r\n    </li>\r\n    <li>    Specify the right way to use a fire extinguisher by using the acronym PASS.\r\n    </li>\r\n    <li>    Recognize when someone can safely stay to fight a fire and when they should flee.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Workplace Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C4246662-9206-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fire Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8985BD40-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Device Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "AFEE64C0-26D0-EE11-9987-005056A7DAD4",
                "course_version": 2,
                "name": "CQ Acute: Documentation for Practitioners, Evaluation and Management (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Tasha Deitschman, MSN, RN, CPPS",
                "description": "This learning activity reviews the elements of necessary documentation for proper evaluation and management (E/M) coding. Learners will review the components of medical decision-making, code sets and their purpose, and descriptors that help code accurately.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize the code sets and documentation that impact code choice.\r\n    </li>\r\n    <li>    Identify necessary medical record documentation for the levels of evaluation and management (E/M) care.\r\n    </li>\r\n    <li>    Specify the components of medical decision-making.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ECB515FE-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Competency: Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2CCAD5F5-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Risk Area: Documentation, Billing and Contracts",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "2810AD61-27D0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "CQ Acute: Documentation for Practitioners, Overview (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Tasha Deitschman, MSN, RN, CPPS",
                "description": "This learning activity provides an overview of documentation for providers. It will review the rationale for accurate medical record documentation, necessary elements, and documentation needed to justify a hospital admission and continued inpatient stay. It will also review common documentation errors.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Specify the criteria and rationale for accurate documentation by healthcare providers.</li>\r\n    <li>Identify the necessary documentation elements.</li>\r\n    <li>Recognize common documentation errors.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2CCAD5F5-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Risk Area: Documentation, Billing and Contracts",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3E45E8CD-1A45-E511-98BC-005056B10E33",
                        "course_category_name": "Billing",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ECB515FE-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "Competency: Documentation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "989A776D-2DD0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "CQ Acute: Stark Law (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Barbara Boyne, MBA, BSN, RN",
                "description": "This learning activity describes the Stark Law and its prohibitions, purpose, and penalties for violations. It also reviews recent changes to the Stark Law and gives examples of Stark exceptions.",
                "learning_objectives_html": "Upon the completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Recognize the Stark Law (Physician Referral Law) and its purpose.</li>\r\n    <li>Describe penalties for violations of the Stark Law.</li>\r\n    <li>Explain how to report a violation of Stark.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FF7753DC-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Stark Law",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "D0A01251-19D0-EE11-9987-005056A7DAD4",
                "course_version": 10,
                "name": "SQ Acute: Workplace Violence (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Valerie Crossland",
                "description": "This learning activity discusses the risks and warning signs of workplace violence in healthcare and provides de-escalation tips to protect self and others. It also presents the elements of an effective workplace violence prevention program.\r\n\r\nEsta actividad de aprendizaje aborda los riesgos y las se\u00f1ales de advertencia de la violencia en el lugar de trabajo en el sector de la salud y ofrece consejos de desescalamiento para protegerse a s\u00ed mismo y a los dem\u00e1s. Tambi\u00e9n presenta los elementos de un programa eficaz de prevenci\u00f3n de la violencia en el lugar de trabajo.",
                "learning_objectives_html": "Upon completion of this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize the risks and warning signs of violence in  the workplace.</li>\r\n    <li>\r\n    Identify de-escalation best practices. </li>\r\n    <li>\r\n    Understand the key elements of a workplace violence prevention plan.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>\r\n    Reconocer los riesgos y las se&ntilde;ales de advertencia de la violencia en el lugar de trabajo.</li>\r\n    <li>Identificar las mejores pr&aacute;cticas de desescalamiento.</li>\r\n    <li>Comprender los elementos clave de un plan de prevenci&oacute;n de la violencia en el lugar de trabajo.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                        "course_category_name": "_SafetyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F913988A-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream SafetyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A337536A-C126-EC11-80E8-005056B135DF",
                        "course_category_name": "Competency: Workplace Violence",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Workforce Culture",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                        "course_category_name": "Clinical Nurse Specialist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "848116E6-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Annual Training",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Rights and Responsibilities",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD11353E-BA97-EB11-80DE-005056B160AF",
                        "course_category_name": "Occupational Stress",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Injury Prevention",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                        "course_category_name": "Registered Nurse First Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                        "course_category_name": "Clinical Preceptor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                        "course_category_name": "Nursing Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                        "course_category_name": "Allied Health Professional",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "43087D1C-26D0-EE11-9987-005056A7DAD4",
                "course_version": 5,
                "name": "CQ Acute: Compliance Program (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Barbara Boyne, MBA, BSN, RN",
                "description": "This learning activity describes the purpose and vital parts of a compliance program. It will discuss compliance risk areas in the healthcare industry and the role of healthcare workers.\r\n\r\nEste m\u00f3dulo describe el prop\u00f3sito y los aspectos esenciales de un programa de cumplimiento. Analizar\u00e1 las \u00e1reas de riesgo de cumplimiento en el sector sanitario y el papel del personal sanitario.",
                "learning_objectives_html": "After completing this learning activity, the participant will be able to:\r\n<ul>\r\n    <li>Recognize the importance and benefits of an effective compliance program.</li>\r\n    <li>Recognize potential risk areas within an organization.</li>\r\n    <li>Appreciate the need to report suspected violations, including what and who to inform.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Reconocer la importancia y los beneficios de un programa de cumplimiento eficaz.</li>\r\n    <li>Reconocer &aacute;reas de riesgo potencial dentro de una organizaci&oacute;n.</li>\r\n    <li>Valorar la necesidad de reportar presuntas violaciones, incluyendo qu&eacute; y a qui&eacute;n se debe informar.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49650B70-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Laws, Acts and Ethics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9F4A29D6-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Fraud, Waste & Abuse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "41F97B70-29D0-EE11-9987-005056A7DAD4",
                "course_version": 6,
                "name": "CQ Acute: HIPAA, Patient Rights (PA; AUD; EN/ES) - for Practitioners",
                "course_type": 1,
                "author_information": "Debbie Curl-Nagy, MSW, LSSMBB",
                "description": "This learning activity reviews the Health Insurance Portability and Accountability Act (HIPAA) Privacy Rule. The purpose and elements of the Notice of Privacy Practices (NPP) are discussed as well as patient rights regarding their protected health information (PHI).\r\n\r\nEsta actividad de aprendizaje revisa la Regla de Privacidad de la Ley de Portabilidad y Responsabilidad del Seguro M\u00e9dico (HIPAA, por sus siglas en ingl\u00e9s). Se analizan el prop\u00f3sito y los elementos del Aviso de Pr\u00e1cticas de Privacidad (NPP), as\u00ed como los derechos de los pacientes en relaci\u00f3n con su informaci\u00f3n de salud protegida (PHI).",
                "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Discuss patient rights under the HIPAA Privacy Rule.</li>\r\n    <li>\r\n    List the four requirements that must be included in the Notice of Privacy Practices.</li>\r\n    <li>\r\n    Relate patient needs for privacy to their rights under the HIPAA Privacy Rule.</li>\r\n</ul>\r\nAl finalizar esta actividad de aprendizaje, el participante podr&aacute;:\r\n<ul>\r\n    <li>Analizar los derechos de los pacientes seg&uacute;n la Regla de Privacidad de HIPAA.</li>\r\n    <li>Enumerar los cuatro requisitos que deben incluirse en el Aviso de Pr&aacute;cticas de Privacidad.</li>\r\n    <li>Relacionar las necesidades de privacidad de los pacientes con sus derechos conforme a la Regla de Privacidad de HIPAA.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "944151B5-2CD0-EE11-9987-005056A7DAD4",
                "course_version": 3,
                "name": "CQ Acute: Medical Identity Theft (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Debbie Curl-Nagy, MSW, LSSMBB",
                "description": "This learning module provides an overview of patient and provider forms of medical identity theft. The content outlines the impact on affected people and the steps that people receiving care, providers, and healthcare organizations can take to prevent medical identity theft.",
                "learning_objectives_html": "Upon the completion of this learning module, the participant will be able to:\r\n<ul>\r\n    <li>Describe medical-related identity theft.</li>\r\n    <li>Distinguish two types of medical identity theft.</li>\r\n    <li>Recognize motivation behind medical identity theft crimes.</li>\r\n    <li>Identify steps that beneficiaries and their providers can take to prevent medical identity theft.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8985BD40-CD8C-EB11-80DF-005056B134EC",
                        "course_category_name": "Device Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D4B3D925-B006-EC11-80E6-005056B16973",
                        "course_category_name": "Competency: Medical Identity Theft",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD11353E-BA97-EB11-80DE-005056B160AF",
                        "course_category_name": "Occupational Stress",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "B922C9AE-9DCE-EF11-9996-005056A7FC7D",
                "course_version": 4,
                "name": "CQ State: HIPAA, Privacy Rule, California (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Carlina Scalf (WGContent)",
                "description": "This learning activity provides an overview of the HIPAA Privacy Rule. It discusses the basic components of the Privacy Rule, including general information and principles on handling protected health information (PHI), an overview of patient rights, general administrative safeguards that protect PHI, an overview of extreme risk protection orders (ERPOs), and how to handle breaches to PHI. It also reviews the Confidentiality of Medical Information Act and the California Consumer Privacy Act. State Training:  This learning activity is intended to assist Customers and Users with understanding and addressing minimum training requirements for all settings in California for this topic. The content provided does not constitute legal or clinical advice and does not guarantee compliance with all applicable federal and state laws and regulations. This course may also satisfy training requirements for other settings in various states; however, no representation or warranty is made as to its applicability. Customers remain solely responsible for ensuring that their training programs comply with all requirements established by their relevant governing entities and that individual care is customized by and aligned with provider orders and facility policies and procedures.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the basic provisions of the Privacy Rule under HIPAA.</li>\r\n    <li>Recognize the requirements and components of the Notice of Privacy Practices.</li>\r\n    <li>Describe the Breach Notification Rule.</li>\r\n    <li>Identify important aspects set by state law that further protect privacy.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A4D0CAF4-0D5B-EF11-9993-005056A73D13",
                        "course_category_name": "Competency: Privacy Laws",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                        "course_category_name": "Case Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Neurology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                        "course_category_name": "Telemetry",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Wound Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Surgery",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Post Anesthesia Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                        "course_category_name": "Progressive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                        "course_category_name": "Orthopedics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                        "course_category_name": "Endoscopy",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                        "course_category_name": "Women's Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A5538AC7-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Residential and Long Term Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                        "course_category_name": "Trauma",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                        "course_category_name": "Perioperative",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Neonatal Intensive Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                        "course_category_name": "Competency: HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                        "course_category_name": "Maternal Newborn",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Oncology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9CBA98F-C688-F011-999D-005056A7F5E9",
                        "course_category_name": "_ComplyQ: State",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "3A60BCE3-A0CE-EF11-9996-005056A7FC7D",
                "course_version": 2,
                "name": "CQ Acute: Texting Compliance in Healthcare, Safety and Privacy (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Carlina Scalf (WGContent)",
                "description": "This learning activity discusses texting compliance in healthcare. It explains the uses and risks of texting in healthcare. It reviews Health Insurance Portability and Accountability Act (HIPAA)-compliant text messaging and discusses best practices for secure texting to prevent privacy violations.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify requirements of text messaging in healthcare. </li>\r\n    <li> List benefits of HIPAA compliant text messaging in healthcare. </li>\r\n    <li> Specify safeguards needed for secure text messaging to prevent privacy violations.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D12F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Human Resources",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                        "course_category_name": "Workforce Culture",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A5538AC7-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Residential and Long Term Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C17A92DE-0BEA-E511-B707-005056B16096",
                        "course_category_name": "Informatics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "362D23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Corporate Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "HIPAA",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A4D0CAF4-0D5B-EF11-9993-005056A73D13",
                        "course_category_name": "Competency: Privacy Laws",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "6F53346C-A2CE-EF11-9996-005056A7FC7D",
                "course_version": 2,
                "name": "CQ Acute: Confidentiality of Substance Use Disorder Patient Records, 42 CFR Part 2 (PA) - for Practitioners",
                "course_type": 1,
                "author_information": "Carleigh Davis (WGContent)",
                "description": "This learning activity covers the confidentiality of substance use disorder (SUD) patient records as mandated by 42 CFR Part 2. It explains the regulations and requirements for protecting the privacy of individuals undergoing SUD treatment, the circumstances under which information can be disclosed, and the penalties for violations.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:\r\n<ul>\r\n    <li>Define the purpose of 42 CFR Part 2.</li>\r\n    <li>Describe the requirements for substance use disorder patient records.</li>\r\n    <li>Identify the importance of maintaining patient privacy and confidentiality.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "All Disciplines",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F4046B6D-8028-EC11-80E8-005056B142C1",
                        "course_category_name": "Content Dev",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "601CC3DB-F296-EF11-9990-005056A773F1",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15703059-FEC4-EE11-9987-005056A7DAD4",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A5538AC7-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Residential and Long Term Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                        "course_category_name": "Risk Area: Privacy and Security",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Behavioral Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                        "course_category_name": "_ComplyQ: Acute",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D096525-FEC4-EE11-998A-005056A74645",
                        "course_category_name": "HSTM - Rapid Regs for Practitioners (Manage Subscribers with Content Package)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "00439C6C-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Child: HSTM - Rapid Regs for Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                        "course_category_name": "HSTM - HealthStream ComplyQ",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "32D502DD-F7CF-EE11-9987-005056A7DAD4",
                        "course_category_name": "Onboarding",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "362D23AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Corporate Compliance",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Home Healthcare",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Ambulatory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                        "course_category_name": "Hospice",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "38B21092-0F5B-EF11-998E-005056A7C0C7",
                        "course_category_name": "Competency: Confidentiality",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            }
        ]
    }
];